import React, {InputHTMLAttributes} from 'react'
import { TextArea, Column, TagError } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLTextAreaElement>{
    error:boolean,
    errorMessage: string,
    height: string,
    handlerOnchange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

function InputComponent({ onBlur, value, error, errorMessage, height, handlerOnchange}:InputProps){
    return(
        <Column error={error} height={height}>
            <TextArea
                onChange={handlerOnchange}
                value={value}
                onBlur={onBlur}
            />
            {error && <TagError>{errorMessage}</TagError>}
        </Column>
    )
}
export default InputComponent;